import React, { useEffect, useState } from 'react';
import './UploadOutComputer.css';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { Input, Button, Form, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { workspaces_List_ActionHandler } from '../../../../../Redux/Actions/user/WorkspacesList';
import { workspaces_Support_Documents_OutputList_ActionHandler } from '../../../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import {
    SupportingDocumentsOutPutFileUploadActionHandler,
    SupportingDocumentsOutPutFileUploadClear,
} from '../../../../../Redux/Actions/user/BuildQuickOutPutFileUploadAction';
import {
    OutPutCreateSupportingDocumentsActionHandler,
    clearDocumentsSupportingData,
} from '../../../../../Redux/Actions/user/BuildQuickOutputCreateSupportingDocumentsAction';
const { Option } = Select;

const UploadOutComputer = ({
    workspaceFolderFlag,
    name,
    isUploadOutComputer,
    context,
    workspace_id,
    folder_id,
    handleCreateOutputFormat,
    handleSupportingDocumentButtonClick,
    DragDropFile,
    setDragDropFile,
    workspace_sd,
    workspaceByIdStatus,
}) => {
    let dispatch = useDispatch();
    const [workspaceId, setWorkspaceId] = useState(null);
    const supportingdocumentsoutputfileuploaddata = useSelector(
        (state) =>
            state?.BuildQuickOutPutFileUploadData
                ?.supporting_documents_out_put_file_upload_data
    );
    const documentssupportingoutputcreatedata = useSelector(
        (state) =>
            state?.BuildQuickOutputCreateSupportingDocumentsData
                ?.documents_supporting_output_create_data
    );
    const [uploadedFile, setUploadedFile] = useState(null);
    const [uploadFileName, setUploadFileName] = useState(
        supportingdocumentsoutputfileuploaddata?.data?.filename
    );
    const [wordCount, setWordCount] = useState(
        supportingdocumentsoutputfileuploaddata?.data?.word_count
    );
    const [content, setContent] = useState(
        supportingdocumentsoutputfileuploaddata?.data?.content
    );
    const [loader, setLoader] = useState(false);
    const formRef = React.createRef();
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );
    const workspaceFolderListData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_document_folderList_data?.data
    );

    //DRAG DROP
    useEffect(() => {
        return () => {
            dispatch(SupportingDocumentsOutPutFileUploadClear());
        };
    }, []);

    useEffect(() => {
        setLoader(false);
    }, [supportingdocumentsoutputfileuploaddata]);

    useEffect(() => {
        if (DragDropFile && DragDropFile[0]?.name) {
            const allowedFileTypes = [
                'application/pdf',
                'audio/mpeg',
                'video/mp4',
                'audio/mp3',
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/doc',
                'application/docx',
                'image/jpeg',
                'image/png',
                'image/jpg',
                'image/tiff',
                'image/bmp',
                'image/heif',
            ];

            if (
                DragDropFile[0].type &&
                allowedFileTypes.includes(DragDropFile[0].type)
            ) {
                const fileName = DragDropFile[0];
                setUploadedFile(fileName);
                dispatch(
                    SupportingDocumentsOutPutFileUploadActionHandler(
                        DragDropFile[0]
                    )
                );
            }
        }
    }, [DragDropFile]);
    //DRAG DROP

    const handleFileChange = (event) => {
        dispatch(SupportingDocumentsOutPutFileUploadClear());
        setLoader(true);
        const file = event.target.files[0];
        const allowedFileExtensions =
            /\.(pdf|mp3|mp4|txt|doc|docx|jpg|jpeg|png|tiff|bmp|heif)$/i;
        if (file && allowedFileExtensions.test(file.name)) {
            dispatch(SupportingDocumentsOutPutFileUploadActionHandler(file));
            setUploadedFile(file);
            // setTimeout(() => {
            //   setLoader(false);
            // }, 2000);
        } else {
            alert('Please select a valid PDF, MP3, or MP4 file.');
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            setUploadFileName(null);
            setWordCount(null);
            setContent(null);
            setLoader(false);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        setLoader(true);
        const file = e.dataTransfer.files[0];
        if (file) {
            const allowedFileTypes = [
                'application/pdf',
                'audio/mpeg',
                'video/mp4',
                'audio/mp3',
                'text/plain',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/doc',
                'application/docx',
                'image/jpeg',
                'image/png',
                'image/jpg',
                'image/tiff',
                'image/bmp',
                'image/heif',
            ];
            if (file && allowedFileTypes.includes(file.type)) {
                dispatch(
                    SupportingDocumentsOutPutFileUploadActionHandler(file)
                );
                setUploadedFile(file);
                setTimeout(() => {
                    setLoader(false);
                }, 2000);
            } else {
                alert('Please select a valid PDF, MP3, or MP4 file.');
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
                setUploadFileName(null);
                setWordCount(null);
                setContent(null);
                setLoader(false);
            }
        } else {
            console.error('No file found in dataTransfer.');
            setLoader(false);
        }
    };
    const handleDeleteClick = () => {
        dispatch(SupportingDocumentsOutPutFileUploadClear());
        setUploadedFile(null);
        setUploadFileName(null);
        setWordCount(null);
        setContent(null);
    };

    const handleDivClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const fileInputRef = React.createRef();

    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));
        setUploadFileName(
            supportingdocumentsoutputfileuploaddata?.data?.filename
        );
        setWordCount(supportingdocumentsoutputfileuploaddata?.data?.word_count);
        setContent(supportingdocumentsoutputfileuploaddata?.data?.content);
    }, [supportingdocumentsoutputfileuploaddata]);

    useEffect(() => {
        if (workspaceId) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspaceId,
                    '',
                    ''
                )
            );
        }
    }, [workspaceId]);

    useEffect(() => {
        if (workspace_sd || workspaceByIdStatus) {
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspace_sd || workspaceByIdStatus,
                    '',
                    ''
                )
            );
        }
    }, [workspace_sd, workspaceByIdStatus]);

    useEffect(() => {
        if (documentssupportingoutputcreatedata) {
            handleCreateOutputFormat(false);
            handleSupportingDocumentButtonClick(false);
            // dispatch(clearDocumentsSupportingData());
        }
    }, [documentssupportingoutputcreatedata, dispatch]);

    const handleChangeWorkspace = (value) => {
        formRef.current.resetFields(['folder_id']);
        setWorkspaceId(value);
    };

    const [uploadInitiated, setUploadInitiated] = useState(false);

    useEffect(() => {
        if (isUploadOutComputer && !uploadInitiated) {
            fileInputRef.current.click();
            setUploadInitiated(true);
        }
    }, []);

    const onFinish = (values) => {
        if (workspace_id || workspaceByIdStatus) {
            workspace_id = workspace_id || workspaceByIdStatus;
        } else {
            workspace_id = values.workspace_id;
        }
        if (folder_id) {
            folder_id = folder_id;
        } else {
            folder_id = values.folder_id;
        }
        const submitObject = {
            workspace_id: parseInt(workspace_id, 10),
            folder_id: parseInt(folder_id, 10),
            name: values.name,
            context: 'This is the ' + values.name + ':',
            type: 'file',
            files: [
                {
                    id: supportingdocumentsoutputfileuploaddata?.data?.id,
                    content:
                        supportingdocumentsoutputfileuploaddata?.data?.content,
                },
            ],
        };
        dispatch(OutPutCreateSupportingDocumentsActionHandler(submitObject));
    };

    let htmlContent = content;

    if (htmlContent != undefined) {
        htmlContent = htmlContent.replace(/\n/g, '<br>');
    }

    let formattedHtml = (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>
    );
    if (typeof formattedHtml == 'string') {
        formattedHtml = formattedHtml?.split('\n').map((str) => <p>{str}</p>);
    }

    useEffect(() => {
        if (uploadFileName) {
            formRef.current.setFieldsValue({
                name: `${name} ${uploadFileName?.replace(/\.[^.]+$/, '')}`,
            });
        }
    }, [uploadFileName]);
    return (
        <>
            {loader ? (
                <>
                    <div
                        className='loader-workspace'
                        style={{
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            zIndex: 1,
                            width: '120px',
                            height: '120px',
                            margin: '-76px 0 0 -76px',
                            border: '16px solid #f3f3f3',
                            borderRadius: '50%',
                            borderTop: '16px solid #3498db',
                            WebkitAnimation: 'spin 2s linear infinite',
                            animation: 'spin 2s linear infinite',
                        }}></div>
                </>
            ) : null}
            <Form
                name='uploadComputerForm'
                initialValues={{
                    name: name,
                    context: 'This is the ' + name + ' :',
                    workspace_id: workspace_sd,
                    foler_id: '',
                }}
                onFinish={onFinish}
                ref={formRef}
                style={{ opacity: loader ? 0.5 : null }}>
                <div className='supporting-document-1'>
                    <label>Supporting document name</label>
                    <Form.Item
                        name='name'
                        rules={[
                            {
                                required: true,
                                message: 'Please input your name!',
                            },
                            {
                                type: 'name',
                                message: 'Please enter a valid name',
                            },
                        ]}>
                        <Input placeholder='Enter your name' />
                    </Form.Item>
                </div>
                {/* <div className="supporting-document-2">
          <label>Context to frame reference data (edit if required)</label>
          <Form.Item
            name="context"
            rules={[
              {
                required: true,
                message: "Please input your context!",
              },
              {
                type: "context",
                message: "Please enter a valid context",
              },
            ]}
          >
            <Input placeholder="Enter your context" />
          </Form.Item>
        </div> */}
                <div className='upload-out-computer-2'>
                    <label>Reference data</label>
                    <div
                        className='upload-out-computer-img-height-320'
                        onClick={handleDivClick}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={handleDrop}>
                        <div className='upload-out-computer-main-div'>
                            <div className='upload-out-computer-span'>
                                {uploadedFile ? (
                                    <>
                                        <div className='upload-out-computer-middle-div-first-p'>
                                            {uploadFileName}
                                            <RiDeleteBin6Fill
                                                className='upload-out-computer-delete-svg'
                                                onClick={handleDeleteClick}
                                            />
                                        </div>
                                        <div className='upload-out-computer-middle-div-second-p'>
                                            Word Count:{' '}
                                            {wordCount?.toLocaleString()}
                                        </div>
                                    </>
                                ) : (
                                    <div className='upload-computer-middle-div-first-p'>
                                        Click to Upload
                                    </div>
                                )}
                            </div>
                        </div>
                        <input
                            type='file'
                            ref={fileInputRef}
                            className='file-none'
                            onChange={handleFileChange}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            accept='.pdf, .mp3, .mp4, .txt, .doc, .docx, application/pdf, audio/mp3, video/mp4, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, image/jpeg, image/png, image/jpg, image/tiff, image/bmp, image/heif'
                        />
                    </div>
                    <div className='upload-out-computer-main-content'>
                        <p>{formattedHtml}</p>
                    </div>
                    {workspaceFolderFlag ? null : (
                        <>
                            <div className='upload-out-computer-modal-div'>
                                <h3>Select Destination Directory</h3>
                            </div>
                            <div className='upload-out-computer-input'>
                                {!workspaceByIdStatus && (
                                    <div className='upload-out-computer-1'>
                                        <label>Select Workspace</label>
                                        <Form.Item
                                            name='workspace_id'
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please select a workspace!',
                                                },
                                            ]}>
                                            <Select
                                                className='uploadcomputer-select'
                                                onChange={
                                                    handleChangeWorkspace
                                                }>
                                                {workspaceData &&
                                                    workspaceData.map(
                                                        (workspace) => (
                                                            <>
                                                                {!workspace.is_locked && (
                                                                    <Option
                                                                        key={
                                                                            workspace.id
                                                                        }
                                                                        value={
                                                                            workspace.id
                                                                        }>
                                                                        {
                                                                            workspace.name
                                                                        }
                                                                    </Option>
                                                                )}
                                                            </>
                                                        )
                                                    )}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                )}
                                <div className='upload-out-computer-2'>
                                    <label>Select Folder</label>
                                    <Form.Item
                                        name='folder_id'
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please select a folder!',
                                            },
                                        ]}>
                                        <Select
                                            className='uploadcomputer-select'
                                            name='folder_id'>
                                            {workspaceFolderListData &&
                                                workspaceFolderListData.map(
                                                    (folder) => (
                                                        <Option
                                                            key={folder.id}
                                                            value={folder.id}>
                                                            {folder.name}
                                                        </Option>
                                                    )
                                                )}
                                        </Select>
                                    </Form.Item>
                                </div>
                            </div>
                        </>
                    )}
                    <div className='upload-out-computer-supporting-div'>
                        <Form.Item>
                            <Button
                                type='primary'
                                htmlType='submit'
                                block
                                className='upload-out-computer-supporting-button'>
                                Create Output Format
                            </Button>
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </>
    );
};
export default UploadOutComputer;
